namespace uh.util {

    export class Functions {

        private static delayedCalls = [];
        public static delayedCall(delay: number, callback: Function, args?: any[], callbackScope?: any): Phaser.Time.TimerEvent | number {
            let scene = game.scene.getAt(0);
            if (scene) {
                let dc = scene.time.delayedCall(delay, callback, args, callbackScope);
                Functions.delayedCalls.push(dc);
                return dc;
            }
            let t = setTimeout(callback, delay);
            Functions.delayedCalls.push(t);
            return t;
        }
        public static pauseAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).paused = true;
                }
            }
        }
        public static resumeAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).paused = false;
                }
            }
        }
        public static destroyAllDelayedCalls() {
            for (let dc of Functions.delayedCalls) {
                if (dc instanceof Phaser.Time.TimerEvent) {
                    (dc as Phaser.Time.TimerEvent).remove(false);
                } else {
                    clearTimeout(dc);
                }
            }
            Functions.delayedCalls = [];
        }
        public static destroyDelayedCall(dc) {
            let ind:number = Functions.delayedCalls.indexOf(dc);
            if (ind >= 0) {
                Functions.delayedCalls.splice(ind, 1);
            }
            if (dc instanceof Phaser.Time.TimerEvent) {
                (dc as Phaser.Time.TimerEvent).remove(false);
            } else {
                clearTimeout(dc);
            }
        }

        public static pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        };

        public static padBack(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : n + new Array(width - n.length + 1).join(z);
        };

        public static toGlobal(object, point?) {
            let pos: { x: number, y: number } = point ? {x: point.x, y: point.y} : {x: 0, y: 0};
            let parentContainer = object;
            while (parentContainer) {
                pos.x *= parentContainer.scaleX;
                pos.y *= parentContainer.scaleY;
                pos.x += parentContainer.x;
                pos.y += parentContainer.y;
                parentContainer = parentContainer.parentContainer;
            }
            return pos;
        }

        public static toLocal(object, point) {
            let path = [];
            let parentContainer = object;
            while (parentContainer) {
                path.push(parentContainer);
                parentContainer = parentContainer.parentContainer;
            }

            let pos: { x: number, y: number } = {x: point.x, y: point.y};
            let p = path.pop();
            do {
                pos.x -= p.x;
                pos.y -= p.y;
                pos.x /= p.scaleX;
                pos.y /= p.scaleY;
                if (path.length > 0) {
                    p = path.pop();
                } else {
                    break;
                }
            } while (true);

            return pos;
        }
    }
}